import { get } from "@ember/object"
import Route from "@ember/routing/route"
import { inject as service } from "@ember/service"
import { hash } from "rsvp"

export default class TemplatesRoute extends Route {
  @service("ember-store")
  store

  model(params) {
    return hash({
      planbook: get(this, "store").find("planbook", this.paramsFor("planbook").planbook_id),
    })
  }

  lastLessonTemplateId = null
}
